import React from "react";
import styles from "../popup.module.scss";
export default function PasswordEdit({ strings, objectToSave, handleInputChange, validateInput, error, }) {
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", { className: "heading1" },
            strings.edit,
            " ",
            strings.password),
        React.createElement("p", null, strings.editDescription),
        React.createElement("div", { className: "input-group" },
            React.createElement("label", { htmlFor: "confirmationPassword" },
                strings.password,
                ":"),
            React.createElement("input", { name: "confirmationPassword", type: "password", value: objectToSave.confirmationPassword, onChange: handleInputChange, onBlur: (e) => validateInput(e.target.name) }),
            React.createElement("span", { className: styles.error }, error.confirmationPasswordErr)),
        React.createElement("div", { className: "input-group" },
            React.createElement("label", { htmlFor: "newPassword" },
                strings.newPassword,
                ":"),
            React.createElement("input", { name: "newPassword", type: "password", value: objectToSave.newPassword, onChange: handleInputChange, onBlur: (e) => validateInput(e.target.name) }),
            React.createElement("span", { className: styles.error }, error.newPasswordErr)),
        React.createElement("div", { className: "input-group" },
            React.createElement("label", { htmlFor: "repeatedNewPassword" },
                strings.repeatNewPassword,
                ":"),
            React.createElement("input", { name: "repeatedNewPassword", type: "password", value: objectToSave.repeatedNewPassword, onChange: handleInputChange, onBlur: (e) => validateInput(e.target.name) }),
            React.createElement("span", { className: styles.error }, error.repeatedNewPasswordErr))));
}
